import { Fragment } from 'react';
import Meta from './../components/Meta';
import Feed from './../components/Feed';

function FeedPage() {
  return (
    <Fragment>
      <Meta title="Showrunner Feed" />
      <Feed mode="list" />
    </Fragment>
  );
}

export default FeedPage;
